<div class="container-fluid spacer-top-navigation">
  <div class="container">
    @if (isPotentialCustomer$ | async) {
      <web-components-back-link />
    }
    <div class="tile">
      <web-design-system-switch
        class="hidden-xl hidden-lg hidden-md d-flex justify-content-end mb-2 mb-md-0"
        [label]="'watchlist.details' | transloco"
        [checked]="details"
        (checkedChange)="toggleDetails()"
      />
      <div class="row">
        <div class="col-12">
          <div class="d-flex flex-grow justify-content-between align-items-center">
            <div class="d-flex">
              <h1 class="zero-text p-huge-med">{{ 'watchlist.headline' | transloco }}</h1>
            </div>
            <div class="d-flex align-items-center">
              @if (downloadUrl) {
                <div class="circle mr-2 cursor-pointer">
                  <a [href]="downloadUrl" target="_blank" rel="noopener noreferrer">
                    <svg class="icon icon-16 text-color-grey">
                      <use xlink:href="/assets/img/svgs/svgset.svg#download-redesign-23" />
                    </svg>
                  </a>
                </div>
              }
              <web-design-system-list-toggle (click)="showPositions = !showPositions" [isCollapsed]="!showPositions" />
            </div>
          </div>
        </div>
      </div>
      @if (showPositions && (watchlistFacade.watchlistInitialLoaded$ | async)) {
        <zero-watchlist [items]="watchlistFacade.watchlist$ | async" [compressed]="!details" />
      }
    </div>
  </div>
</div>
